<template>
  <div class="gift-information__container white-back-container">
    <div class="white-back-container__content">
      <div class="gift-information__header white-back-container__header">
        <h3 class="subhead-bold">お届けするギフト</h3>
      </div>
      <div class="white-back-container__inner-content">
        <div class="ticket-box">
          <span class="ticket-image">
            <ImgLazy
              :image-url="imageUrl"
              :alt-text="itemName"
              aspect-ratio="1"
              width="72"
              height="72"
              class="ticket-image-container"
            />
          </span>
          <div class="ticket-info">
            <p class="ticket__brand--small">
              {{ brandName }}
            </p>
            <p class="ticket__item-name">
              {{ itemName }}
            </p>
            <p v-if="itemSkuName" class="ticket__item-min-unit">
              {{ itemSkuName }}
            </p>
            <div class="gift-information__links">
              <button
                type="button"
                class="gift-information__link"
                @click="onClickGiftInfo"
              >
                <GiftOutline class="gift-information__link-icon" />
                <span class="gift-information__link-text">ギフト情報</span>
              </button>
              <button
                v-if="showShippingInfoButton"
                type="button"
                class="gift-information__link"
                @click="onClickShippingInfo"
              >
                <CarOutline class="gift-information__link-icon" />
                <span class="gift-information__link-text">発送情報</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <GiftInfoModal
      v-if="showGiftInfoModal"
      :description-html="descriptionHtml"
      @clicked-modal-cover="closeGiftInfoModal"
      @clicked-close="closeGiftInfoModal"
    />
    <ShippingInfoModal
      v-if="showShippingInfoModal"
      :mail-slot-deliverable="mailSlotDeliverable"
      :notice-detail="noticeDetail"
      @clicked-modal-cover="closeShippingInfoModal"
      @clicked-close="closeShippingInfoModal"
    />
  </div>
</template>

<script>
import ImgLazy from '../../../../atoms/images/ImgLazy.vue'
import GiftOutline from '../../../../atoms/svg_icons/GiftOutline.vue'
import CarOutline from '../../../../atoms/svg_icons/CarOutline.vue'
import GiftInfoModal from './GiftInfoModal.vue'
import ShippingInfoModal from './ShippingInfoModal.vue'

export default {
  components: {
    ImgLazy,
    GiftOutline,
    CarOutline,
    GiftInfoModal,
    ShippingInfoModal
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    descriptionHtml: {
      type: String,
      required: false,
      default: ''
    },
    mailSlotDeliverable: {
      type: Boolean,
      required: false,
      default: false
    },
    noticeDetail: {
      type: Object,
      required: false,
      default: null
    }
  },
  data() {
    return {
      showGiftInfoModal: false,
      showShippingInfoModal: false
    }
  },
  computed: {
    showShippingInfoButton() {
      // mailSlotDeliverableが表示される場合
      if (this.mailSlotDeliverable) {
        return true
      }

      // NoticeAreaのitems-show__item-notice-wrapperが表示される場合
      // isShippingInfoModal: trueの場合に表示される項目をチェック
      if (this.noticeDetail) {
        // showDeliveryEstimate
        const deliveryEstimate = this.noticeDetail.deliveryEstimate
        const isDeliveryEstimatePending = !deliveryEstimate?.type
        const showDeliveryHolidayPeriodDescription =
          deliveryEstimate?.holidayPeriodDescription &&
          deliveryEstimate.holidayPeriodDescription.trim() !== ''
        const showGifteeSystemNote = deliveryEstimate?.useGifteeSystem === true
        const showDeliveryEstimate =
          !isDeliveryEstimatePending ||
          showDeliveryHolidayPeriodDescription ||
          showGifteeSystemNote

        // showRefrigeratedShipping
        const refrigeratedShipping = this.noticeDetail.refrigeratedShipping
        const showRefrigeratedShipping = !!refrigeratedShipping?.type

        // showRedelivery
        const redelivery = this.noticeDetail.redelivery
        const isRedeliveryPending = !redelivery?.costBearerType
        const showRedeliveryDescription =
          redelivery?.description && redelivery.description.trim() !== ''
        const showRedelivery = !isRedeliveryPending || showRedeliveryDescription

        if (
          showDeliveryEstimate ||
          showRefrigeratedShipping ||
          showRedelivery
        ) {
          return true
        }
      }

      return false
    }
  },
  methods: {
    onClickGiftInfo() {
      this.showGiftInfoModal = true
    },
    onClickShippingInfo() {
      this.showShippingInfoModal = true
    },
    closeGiftInfoModal() {
      this.showGiftInfoModal = false
    },
    closeShippingInfoModal() {
      this.showShippingInfoModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
.ticket-box {
  display: flex;
}

.ticket-image {
  height: 100%;
  font-size: 0;

  .ticket-image-container {
    border-radius: 8px;
  }
}

.ticket-info {
  overflow: hidden;
  width: 100%;
  padding-left: 16px;
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 4px;
}

.ticket__item-name,
.ticket__item-min-unit {
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 1.6;
  word-break: break-all;
  color: $black;
  margin: 0;
}

.ticket__brand--small {
  line-height: 1.6;
  color: $gray-1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: bold;
  font-size: 1.2rem;
  margin: 0;
}

.gift-information__links {
  display: flex;
  gap: 16px;
  padding-top: 8px;
}

.gift-information__link {
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.gift-information__link-icon {
  width: 20px;
  height: 20px;
  color: $link;
}

.gift-information__link-text {
  @extend %body;
  color: $link;
}
</style>
